import { Grid } from "@mui/material";
import CreateSettingCourier from "./SettingCourierActions/CreateSettingCourier";
const AdminCourierActions = ({
  loading,
  error,
  createCourier,
  templates,
}) => {
  return (
    <Grid container>
      <CreateSettingCourier
        loading={loading}
        error={error}
        createCourier={createCourier}
        templates={templates}
      />
    </Grid>
  );
};

export default AdminCourierActions;
